import React, {Component} from 'react'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'

import AddCategoryIcon from '@material-ui/icons/AddCircle'

import PaperBlock from "../../ui/PaperBlock"

import SelectCategoryDialog from "../SelectCategoryDialog"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <CategoriesPanel title categories onAttachCategory = {category} onDetachCategory = {category}/>
 */

class CategoriesPanel extends Component {

	render() {
		return <PaperBlock style = {{display: "flex", flexDirection: "column", 
			flexGrow: "1",
			flexShrink: "1",
			flexBasis: "0",
		}}>

			<div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>

				<Typography style = {{flex: "1 1 auto"}}>{this.props.title}</Typography>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (this.props.parent) {
							this.props.parent.setState({
								dialog: <SelectCategoryDialog
									onSelectCategory = {category => {
										if (typeof this.props.onAttachCategory === "function") {
											this.props.onAttachCategory(category)
										}
										this.props.parent.setState({
											dialog: undefined
										})
									}}
									onCancel = {() => {
										this.props.parent.setState({
											dialog: undefined
										})
									}}
								/>
							})
						}
					}}
				>
					<AddCategoryIcon className = {this.props.classes.AddCategoryIcon}/>
					Добавить
				</Button>

			</div>

			<div>

				{this.props.categories ? this.props.categories.map((category, n) => <Chip
					className = {this.props.classes.chip}
					key = {n}
					label = {category.name}
					onDelete = {() => {
						if (typeof this.props.onDetachCategory === "function") {
							this.props.onDetachCategory(category)
						}
					}}
				/>) : null}

			</div>

		</PaperBlock>
		
	}

}

export default withStyles(theme => ({
	chip: {
		margin: theme.spacing.unit
	},
	AddCategoryIcon: {
		marginRight: theme.spacing.unit
	}
}))(CategoriesPanel)
